module.exports = __webpack_public_path__ + "static/media/icon_fork.c390a2f8.svg";